/** Basic UI component for a Tag
 * style guide ultimately calls for this to have hover, cursor states
 */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './Tag.css';

/** @deprecated = Please use TagV2 */
const Tag = ({ children, size, type, className, hasHoverState, onClick, emoji }) => (
  <div
    onClick={onClick}
    className={cx(
      'zola-ui',
      'tag',
      `tag--${size}`,
      `tag--${type}`,
      { 'hover-state': hasHoverState },
      className
    )}
  >
    {type === 'emoji' ? (
      <Fragment>
        <span role="img" aria-label={emoji.ariaLabel} className="symbol">
          {emoji.symbol}
        </span>
        {children}
      </Fragment>
    ) : (
      children
    )}
    {(type === 'filter' || type === 'white-filter') && (
      <i className="zola-ui-icon zola-ui-icon-close" />
    )}
  </div>
);

Tag.defaultProps = {
  size: 'lg',
  type: 'primary',
};

Tag.propTypes = {
  /** Size of the tag.
   * NOTE: size will be ignored when type is "filter" or "emoji"
   * */
  size: PropTypes.oneOf(['sm', 'lg']),
  /** type of the tag. Different style will be applied */
  type: PropTypes.oneOf([
    'primary',
    'secondary',
    'light-navy',
    'alternate',
    'red',
    'orange',
    'filter',
    'white-filter',
    'emoji',
  ]),
  /** contents to be rendered for the tag */
  children: PropTypes.node,
  /** self descriptive */
  className: PropTypes.string,
  /** self descriptive */
  onClick: PropTypes.func,
  /** flag for showing style in hover state */
  hasHoverState: PropTypes.bool,
  /** Should be used with 'emoji' tag type. Example: { ariaLabel: 'blue heart emoji', symbol: '💙' } */
  emoji: PropTypes.shape({
    ariaLabel: PropTypes.string.isRequired,
    symbol: PropTypes.string.isRequired,
  }),
};

export default Tag;
